interface Agent {
  agent_id: string;
  agent_name: string;
  description: string;
  category: string;
  icon_id: string;
  created_by: string;
  example_prompts?: string[];
  redirect_url: string;
}
interface Data {
  agents: Agent[];
  label: string;
}

interface ResponseData {
  data: Data;
  message: string;
  status: string;
}
//interface for allDivisionsList and Location
interface DivisionState {
  allDivisionsList: string[];
  setDivisionApiRes: (allDivisionsList: string[]) => void;
}

interface LocationState {
  location: string[];
  setLocationApiRes: (location: string[]) => void;
}
interface GroupState extends DivisionState, LocationState {
  Global_Apps: { All: ResponseData }[];
  App_Marketplace: { All: ResponseData }[];
  My_Apps: { All: ResponseData }[];
  Share_with_Me: { All: ResponseData }[];

  setGroupData: (rawData: any) => void;
  getDataByLabel: (label: string) => ResponseData;
  setMyAppsData: (data: Agent[]) => void;
  getAllAgents: () => Agent[];
  getAgentById: (agentId: string) => Agent | undefined;
}

// Define labels in one place as constants
const LABELS = {
  GLOBAL_APPS: 'Global AI Apps',
  APP_MARKETPLACE: 'AI App Marketplace',
  MY_APPS: 'My AI Apps',
  SHARE_WITH_ME: 'Shared with Me',
};

const initializeGroupState: GroupState = {
  Global_Apps: [{ All: { data: { agents: [], label: '' }, message: '', status: '' } }],
  App_Marketplace: [{ All: { data: { agents: [], label: '' }, message: '', status: '' } }],
  My_Apps: [{ All: { data: { agents: [], label: '' }, message: '', status: '' } }],
  Share_with_Me: [{ All: { data: { agents: [], label: '' }, message: '', status: '' } }],

  //allDivisionsList & location states
  allDivisionsList: [],
  location: [],

  setGroupData: () => {},
  getDataByLabel: () => {
    return {
      data: { agents: [], label: '' },
      message: '',
      status: '',
    };
  },
  // independent setters
  setDivisionApiRes: () => {},
  setLocationApiRes: () => {},
  setMyAppsData: () => {},
  getAllAgents: () => [],
  getAgentById: () => undefined,
};

export const groupSlice = (set, get): GroupState => ({
  ...initializeGroupState,

  setGroupData: (rawData: any[]) => {
    const transformed: Partial<GroupState> = {};

    rawData.forEach((group) => {
      const data = group?.data || [];

      switch (group.type) {
        case LABELS.GLOBAL_APPS:
          transformed.Global_Apps = [{ All: data }];
          break;
        case LABELS.APP_MARKETPLACE:
          transformed.App_Marketplace = [{ All: data }];
          break;
        case LABELS.MY_APPS:
          transformed.My_Apps = [{ All: data }];
          break;
        case LABELS.SHARE_WITH_ME:
          transformed.Share_with_Me = [{ All: data }];
          break;
      }
    });

    set((state) => ({ ...state, ...transformed }));
  },

  getDataByLabel: (label: string) => {
    const state = get();

    switch (label) {
      case LABELS.GLOBAL_APPS:
        return state.Global_Apps[0]?.All || {};
      case LABELS.APP_MARKETPLACE:
        return state.App_Marketplace[0]?.All || {};
      case LABELS.MY_APPS:
        return state.My_Apps[0]?.All || {};
      case LABELS.SHARE_WITH_ME:
        return state.Share_with_Me[0]?.All || {};
      default:
        return {};
    }
  },

  getAllAgents: () => {
    const state = get();

    return [
      ...(state.Global_Apps[0]?.All?.data?.agents ?? []),
      ...(state.App_Marketplace[0]?.All?.data?.agents ?? []),
      ...(state.My_Apps[0]?.All?.data?.agents ?? []),
      ...(state.Share_with_Me[0]?.All?.data?.agents ?? []),
    ];
  },

  getAgentById: (agentId: string) => {
    return get()
      .getAllAgents()
      .find((agent) => agent.agent_id === agentId);
  },

  setDivisionApiRes: (allDivisionsList: string[]) => {
    set((state) => ({ ...state, allDivisionsList }));
  },

  setLocationApiRes: (location: string[]) => {
    set((state) => ({ ...state, location }));
  },
  setMyAppsData: (data: Agent[]) => {
    // Update the agents list inside My_Apps[0].All.data.agents
    set((state) => ({
      ...state,
      My_Apps: [
        {
          All: {
            ...state.My_Apps[0].All,
            data: { ...state.My_Apps[0].All.data, agents: data },
          },
        },
      ],
    }));
  },
});
